export default "__VITE_ASSET__DGfhtIvr__"